/**
 * A utility module that provides camera provider and camera type mappings for the application.
 *
 * The module exports four properties:
 * - CompanyMap: a mapping of camera provider names to user-facing company names.
 * - ProviderMap: a mapping of company names to the camera types they use.
 * - ProviderNames: an array of all provider names.
 * - CompanyNames: an array of all company names.
 *
 * Example usage:
 * ```
 * import { cameraMappings } from '../../src/_utils/camera-utils'
 *
 * const openEyeName = cameraMappings.CompanyMap.UAS; // returns 'openeye'
 *
 * const openEyeCameraTypes = cameraMappings.ProviderMap.openeye; // returns ['UAS', 'Shore Systems', 'Itech Digital']
 *
 * const providerNames = cameraMappings.ProviderNames; // returns ['openeye', 'dtiq', 'itech', 'solink', 'wachter', 'envysion', 'lemon']
 *
 * const companyNames = cameraMappings.CompanyNames; // returns ['UAS', 'Shore Systems', 'Itech Digital', 'DTIQ', 'ITECH', 'Solink', 'Wachter', 'Envysion', 'Lemon']
 * ```
 */

export const CompanyMap = {
  UAS: 'openeye',
  'Shore Systems': 'openeye',
  'iTech Digital': 'openeye',
  DTiQ: ['dtiq', 'DTIQ'],
  ITECH: 'itech',
  Solink: 'solink',
  Wachter: 'wachter',
  IPConfigure: 'ipconfigure',
  Envysion: 'envysion',
  'AI Vision Technologies': 'lemon',
  'Remote Ally': 'remoteally',
};

export const ProviderMap = {
  UAS: 'UAS',
  openeye: 'UAS',
  'Open Eye': 'UAS',
  'Shore Systems': 'Shore Systems',
  'Itech Digital': 'Itech Digital',
  Envysion: 'Envysion',
  envysion: 'Envysion',
  Solink: 'Solink',
  solink: 'Solink',
  ITECH: 'ITECH',
  itech: 'ITECH',
  lemon: 'AI Vision Technologies',
  Lemon: 'AI Vision Technologies',
  'AI Vision Technologies': 'AI Vision Technologies',
  wachter: 'Wachter',
  Wachter: 'Wachter',
  DTIQ: 'DTiQ',
  DTiQ: 'DTiQ',
  IPConfigure: 'IPConfigure',
  ipconfigure: 'IPConfigure',
  remoteally: 'Remote Ally',
};

export const ProviderNames = [
  'openeye',
  'dtiq',
  'itech',
  'solink',
  'wachter',
  'envysion',
  'lemon',
  'ipconfigure',
  'remoteally',
];

export const CompanyNames = [
  'UAS',
  'Shore Systems',
  'iTech Digital',
  'DTiQ',
  'ITECH',
  'Solink',
  'Wachter',
  'Envysion',
  'AI Vision Technologies',
  'IPConfigure',
  'Remote Ally',

]
